// src/components/accueil/GroupeMachine.tsx — SCE Issues
// Regroupement par N° de série dans les cartes de l'accueil (02/10) : le bouton
// « Par machine » de l'en-tête de carte, et le titre de chaque groupe.
//
// Mêmes gestes que les titres de groupe du tableau de « Tous les problèmes » :
// le N° de série ouvre la fiche équipement, le chevron replie le groupe.

import { ChevronDown, ChevronRight, Layers } from 'lucide-react'
import { useOuvrirFiche } from '@/components/layout/ModaleRoute'
import { lienEquipement } from '@/utils/liensFiches'
import { SANS_MACHINE } from '@/utils/accueil'

/** `compact` : l'icône seule (en-tête déjà chargé, comme celui de l'activité). */
export function BoutonParMachine({
  actif,
  onChange,
  compact = false,
}: {
  actif: boolean
  onChange: (actif: boolean) => void
  compact?: boolean
}): JSX.Element {
  return (
    <button
      type="button"
      className={'accueil-par-machine' + (actif ? ' accueil-par-machine--actif' : '')}
      aria-pressed={actif}
      aria-label="Regrouper par N° de série"
      title={actif ? 'Regroupé par N° de série : revenir à la liste simple' : 'Regrouper par N° de série'}
      onClick={() => onChange(!actif)}
    >
      <Layers size={15} />
      {!compact && 'Par équipement'}
    </button>
  )
}

export function TitreGroupeMachine({
  cle,
  pn,
  detail,
  replie,
  nouveau,
  onBascule,
}: {
  /** N° de série en majuscules, ou SANS_MACHINE. */
  cle: string
  pn: string
  /** « 3 problèmes », « 2 problèmes · 5 événements ». */
  detail: string
  replie: boolean
  /** Le groupe contient du nouveau depuis la dernière visite. */
  nouveau?: boolean
  onBascule: () => void
}): JSX.Element {
  const ouvrirFiche = useOuvrirFiche()
  const sans = cle === SANS_MACHINE
  return (
    <div className="accueil-groupe">
      <button
        type="button"
        className="accueil-groupe-chevron"
        aria-expanded={!replie}
        aria-label={`${replie ? 'Déplier' : 'Replier'} ${cle}`}
        onClick={onBascule}
      >
        {replie ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
      </button>
      <button
        type="button"
        className={'accueil-groupe-titre' + (sans ? '' : ' accueil-groupe-titre--lien')}
        title={sans ? undefined : 'Ouvrir la fiche équipement'}
        onClick={() => (sans ? onBascule() : ouvrirFiche(lienEquipement(cle)))}
      >
        <b>{cle}</b>
        {pn && <span>{pn}</span>}
      </button>
      <span className="accueil-groupe-detail">
        {nouveau && <span className="accueil-groupe-nouveau" title="Du nouveau depuis votre dernière visite" />}
        {detail}
      </span>
    </div>
  )
}

export const pluriel = (n: number, mot: string): string => `${n} ${mot}${n > 1 ? 's' : ''}`
